import { Injectable } from "@angular/core";
import { PlatformType } from "@root/config";

// const rules = [
//   "min_stay_through",
//   "max_stay_through",
//   "min_stay_on_arrival",
//   "max_stay_on_arrival",
//   "exact_stay_on_arrival",
//   "min_advance_reservation",
//   "max_advance_reservation",
//   "closed_on_arrival",
//   "closed_on_departure",
//   "rule_id",
// ] as const;

// export type Rule1 = typeof rules[number];

export type Rule =
  | "min_stay_through"
  | "max_stay_through"
  | "min_stay_on_arrival"
  | "max_stay_on_arrival"
  | "exact_stay_on_arrival"
  | "min_advance_reservation"
  | "max_advance_reservation"
  | "closed_on_arrival"
  | "closed_on_departure"
  | "rule_id";

export type Field = "mixed" | Rule;

@Injectable({
  providedIn: "root",
})
export class BatchModifyRestrictionsService {
  private readonly PlatformsSupportRestrictions = [
    PlatformType.Airbnb,
    PlatformType.Booking,
    PlatformType.Vrbo,
    PlatformType.Agoda,
    PlatformType.Bookingsite,
    PlatformType.Expedia,
    PlatformType.Houfy,
  ];

  private readonly AirbnbSupportedRules: Partial<Rule>[] = [
    "min_stay_on_arrival",
    "max_stay_on_arrival",
    "closed_on_arrival",
    "closed_on_departure",
    "rule_id",
  ];

  private readonly AgodaSupportedRules: Partial<Rule>[] = [
    "min_stay_on_arrival",
    "closed_on_arrival",
    "closed_on_departure",
    "min_stay_through",
    "max_stay_through",
  ];

  private readonly BookingsiteSupportedRules: Partial<Rule>[] = [
    "min_stay_on_arrival",
    "max_stay_on_arrival",
    "closed_on_arrival",
    "closed_on_departure",
  ];

  private readonly BookingSupportedRules: Partial<Rule>[] = [
    "min_stay_on_arrival",
    "max_stay_on_arrival",
    "closed_on_arrival",
    "closed_on_departure",
    "min_stay_through",
    "max_stay_through",
    "min_advance_reservation",
    "max_advance_reservation",
    "exact_stay_on_arrival",
  ];

  private readonly ExpediaSupportedRules: Partial<Rule>[] = [
    "min_stay_on_arrival",
    "max_stay_on_arrival",
    "closed_on_arrival",
    "closed_on_departure",
  ];

  private readonly VrboSupportedRules: Partial<Rule>[] = ["min_stay_on_arrival"];

  private readonly HoufySupportedRules: Partial<Rule>[] = [
    "min_stay_on_arrival",
    "closed_on_arrival",
    "closed_on_departure",
  ];

  constructor() {}

  /**
   * 渠道是否支持修改规则
   */
  isSupportRestrictions(platform: PlatformType) {
    return this.PlatformsSupportRestrictions.includes(platform);
  }

  /**
   * 平台是否支持某个规则
   */
  isPlatformSupportRule(platform: PlatformType, rule: Rule) {
    switch (platform) {
      case PlatformType.Airbnb: {
        return this.AirbnbSupportedRules.indexOf(rule) !== -1;
      }
      case PlatformType.Agoda: {
        return this.AgodaSupportedRules.indexOf(rule) !== -1;
      }
      case PlatformType.Booking: {
        return this.BookingSupportedRules.indexOf(rule) !== -1;
      }
      case PlatformType.Bookingsite: {
        return this.BookingsiteSupportedRules.indexOf(rule) !== -1;
      }
      case PlatformType.Expedia: {
        return this.ExpediaSupportedRules.indexOf(rule) !== -1;
      }
      case PlatformType.Vrbo: {
        return this.VrboSupportedRules.indexOf(rule) !== -1;
      }
      case PlatformType.Houfy: {
        return this.HoufySupportedRules.indexOf(rule) !== -1;
      }

      default:
        return false;
    }
  }

  /**
   * 支持修改该规则的所有渠道
   */
  platformsSupportThisRule(rule: Rule): PlatformType[] {
    return this.PlatformsSupportRestrictions.filter((p) => this.isPlatformSupportRule(p, rule));
  }
}
